<template>
  <div class="overall-stats">
    <!-- 时间筛选栏 -->
    <div class="time-filter">
      <div class="div-bg tabs1">
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick">
          <el-tab-pane label="全部" name="-1"></el-tab-pane>
          <el-tab-pane label="一年" name="365"></el-tab-pane>
          <el-tab-pane label="半年" name="180"></el-tab-pane>
          <el-tab-pane label="30天" name="30"></el-tab-pane>
          <el-tab-pane label="24小时" name="1"></el-tab-pane>
          <el-tab-pane label="自定义设置" name="cus"></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 自定义设置时显示 right-circle-list -->
    <right-circle-list v-if="activeName === 'cus'" :key="kfsl_val" :days="kfsl_val"></right-circle-list>

    <!-- 统计卡片 -->
    <div class="stats-cards">
      <div class="stat-card" v-for="(stat, index) in statsData" :key="index">
        <div class="stat-ring">
          <img :src="getStatImage(stat.label)" alt="" class="stat-icon" />
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ formatValue(stat.value) }}</div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import rightCircleList from "./rightCircleList.vue";

export default {
  name: 'OverallStats',
  components: {
    rightCircleList,
  },
  data() {
    return {
      activeName: '-1',
      kfsl_val: '-1',
      statsData: [
        {
          label: '开方量',
          value: 13973400,
          unit: '万',
          color: '#73c0de',
          percent: 75
        },
        {
          label: '销售额',
          value: 768000000,
          unit: '亿',
          color: '#91cc75',
          percent: 80
        },
        {
          label: '云诊所',
          value: 4516,
          unit: '',
          color: '#91cc75',
          percent: 70
        }
      ]
    }
  },
  methods: {
    handleClick(e) {
      this.activeName = e.name
      this.kfsl_val = e.name
      // 这里可以调用接口获取对应时间段的数据
      this.loadData()
    },
    loadData() {
      // this.$http.get('query_kf_xs')
      // 根据 activeName 加载数据
      this.$http.get(process.env.VUE_APP_API_HOST + "/query_kf_xs").then((res) => {
        console.log(res)
        // 更新 statsData
      })
    },
    formatValue(value) {
      if (value >= 100000000) {
        // 亿
        return (value / 100000000).toFixed(2) + '亿'
      } else if (value >= 10000) {
        // 万
        return (value / 10000).toFixed(2) + '万'
      } else {
        // 普通数字，添加千分位
        return value.toLocaleString()
      }
    },
    getStatImage(label) {
      const imageMap = {
        '开方量': require('@/assets/map/chufangliang.png'),
        '销售额': require('@/assets/map/xiaoshoue.png'),
        '云诊所': require('@/assets/map/yunzhensuo.png')
      }
      return imageMap[label] || require('@/assets/map/chufangliang.png')
    },
  },
  mounted() {
    this.handleClick({ name: this.activeName })
  }
}
</script>

<style lang="scss" scoped>
.overall-stats {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #fff;

  .time-filter {
    padding: 10px 0;
    // margin-bottom: 20px;
    flex-shrink: 0;

    .div-bg {
      height: 100%;
    }
  }

  .stats-cards {
    flex: 1;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 20px;
    min-height: 0;
    padding: 20px 0;

    .stat-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 25px 15px;
      transition: all 0.3s ease;
      // border-radius: 8px;
      // background: linear-gradient(135deg, rgba(116, 255, 190, 0.05) 0%, rgba(116, 255, 190, 0.02) 100%);
      // border: 1px solid rgba(116, 255, 190, 0.1);

      &:hover {
        // background: linear-gradient(135deg, rgba(116, 255, 190, 0.1) 0%, rgba(116, 255, 190, 0.05) 100%);
        // border-color: rgba(116, 255, 190, 0.3);
        transform: translateY(-5px);
        // box-shadow: 0 8px 20px rgba(116, 255, 190, 0.15);
      }

      .stat-ring {
        width: 45px;
        height: auto;
        margin-bottom: 20px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        filter: drop-shadow(0 4px 8px rgba(116, 255, 190, 0.3));

        .stat-icon {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transition: transform 0.3s ease;
        }
      }

      &:hover .stat-ring .stat-icon {
        transform: scale(1.1);
      }

      .stat-content {
        text-align: center;
        width: 100%;
        .stat-value {
          font-size: 12px;
          font-weight: 700;
          color: #fff;
          line-height: 1.2;
          margin-bottom: 10px;
          text-shadow: 0 2px 10px rgba(116, 255, 190, 0.3);
          letter-spacing: 1px;
          font-family: 'Arial', sans-serif;
        }

        .stat-label {
          font-size: 14px;
          color: #74ffbe;
          line-height: 1.2;
          font-weight: 500;
          letter-spacing: 0.5px;
        }
      }
    }
  }
}

@media (max-width: 1400px) {
  .overall-stats {
    .stats-cards {
      gap: 5px;
      padding: 15px 0;
      .stat-card {
        padding: 20px 5px;

        .stat-ring {
          width: 45px;
          height: auto;
          // margin-bottom: 15px;
        }

        .stat-content {

          .stat-label {
            font-size: 13px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.overall-stats {
  .el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: transparent;
    z-index: 1;
  }

  .tabs1 .el-tabs__item {
    width: 100px;
    // margin-top: 30px;
    // line-height: 0;
    font-size: 14px;
  }
  .el-tabs__item.is-active{
    color: #74ffbe;
  }
  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    line-height: 60px;
    color: #74ffbe;
    font-size: 20px;
  }

  .el-tabs__item {
    color: #ccc !important;
    text-align: center;
  }

  .is-active {
    color: #fff !important;
    font-weight: bold !important;
  }

  /*tabs 去掉el-tab-pane切换时的蓝色下划线*/
  .el-tabs__active-bar {
    background-color: rgba(96, 252, 178, 1) !important;
    height: 2px;
  }
}
</style>

